import { getTreatmentApproaches } from '@uplift/api';
import { useCallback } from 'react';


export const useTreatments = () => {
  const fetchTreatments = useCallback(async () => {
    const response = await getTreatmentApproaches();

    return response.data;
  }, []);

  return { fetchTreatments };
};
